export default "__VITE_ASSET__Cf6bpuTb__"